import * as React from "react";
const SvgMultidevice = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M5.625 1.871v5.914h1.498V3.38H20.621v9.744h-3.465v1.508H22.13V1.872h-8.252ZM1.871 9.37v9.945H7.97v1.307l-1.5.002-1.5.002-.004.752-.002.75h7.508v-1.506H9.465v-1.307h6.098V9.37H8.716Zm1.508 1.508H14.064v6.932H3.38v-3.467z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgMultidevice;
